var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import WixComponent from '../BaseComponents/WixComponent';

import styles from './ToggleSwitch.scss';

var ToggleSwitch = function (_WixComponent) {
  _inherits(ToggleSwitch, _WixComponent);

  function ToggleSwitch(params) {
    _classCallCheck(this, ToggleSwitch);

    var _this = _possibleConstructorReturn(this, (ToggleSwitch.__proto__ || Object.getPrototypeOf(ToggleSwitch)).call(this, params));

    _this.id = uniqueId();
    return _this;
  }

  _createClass(ToggleSwitch, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          checked = _props.checked,
          onChange = _props.onChange,
          size = _props.size,
          disabled = _props.disabled;

      var id = this.id;
      var rootClassName = classnames(styles.toggleSwitch, (_classnames = {}, _defineProperty(_classnames, styles.toggleSwitchSmall, size === 'small'), _defineProperty(_classnames, styles.toggleSwitchXSmall, size === 'x-small'), _defineProperty(_classnames, styles.disabled, disabled), _classnames));

      var outerLabel = classnames(styles.outerLabel, _defineProperty({}, styles.disabled, disabled));

      var innerLabel = classnames(styles.innerLabel, _defineProperty({}, styles.disabled, disabled));

      var toggleActive = classnames(styles.toggleActive, _defineProperty({}, styles.disabled, disabled));

      var toggleInactive = classnames(styles.toggleInactive, _defineProperty({}, styles.disabled, disabled));

      return React.createElement(
        'div',
        { className: rootClassName },
        React.createElement('input', { type: 'checkbox', id: id, checked: checked, onChange: onChange }),
        React.createElement(
          'label',
          { htmlFor: id, className: outerLabel },
          React.createElement(
            'label',
            { htmlFor: id, className: innerLabel },
            React.createElement(
              'svg',
              { className: toggleActive, viewBox: '0 0 41 32' },
              React.createElement('path', { d: 'M0.169 17.815c0.169 1.098 0.76 2.111 1.689 2.871l14.269 10.385c1.942 1.435 4.644 1.013 6.079-0.844l18.069-23.303c1.435-1.858 1.098-4.559-0.844-5.995s-4.644-1.098-6.164 0.844l-15.367 19.842-10.723-7.852c-1.942-1.435-4.644-1.013-6.164 0.844-0.76 0.929-1.013 2.111-0.844 3.208z' })
            ),
            React.createElement(
              'svg',
              { className: toggleInactive, viewBox: '0 0 143 32' },
              React.createElement('path', { d: 'M0 0h142.545v32h-142.545v-32z' })
            )
          )
        )
      );
    }
  }]);

  return ToggleSwitch;
}(WixComponent);

ToggleSwitch.displayName = 'ToggleSwitch';
ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['x-small', 'small', 'large'])
};

ToggleSwitch.defaultProps = {
  checked: false,
  onChange: function onChange() {},
  disabled: false,
  size: 'large'
};

export default ToggleSwitch;
//# sourceMappingURL=ToggleSwitch.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/ToggleSwitch/ToggleSwitch.js